import React, { Component } from 'react';
import {Image } from 'react-bootstrap';
import { loadingConsulting } from '../../../Images/Images';
import Draggable from 'react-draggable';
import { connect } from 'react-redux';
import { Singleton } from '../../../js/Singleton';

class Consulting extends Component{

  constructor(props){
    super(props);
    this.language = new Singleton();
  }

  render() {
    return (
      <div className="noAvailableLocked">
        <Draggable bounds="parent">
          <div className="windowConsulting">
            <p className="consultingTitle">{this.language.getText('CallControlIVRInputidleMsglabel')}</p>
            <Image className="consultingImage" src={loadingConsulting}></Image>
          </div>
       </Draggable>
      </div>
    );
  }
}

export default Consulting = connect(
  null,
  null
)(Consulting);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/Consulting.jsx